/*
 * @Author: your name
 * @Date: 2020-11-18 15:11:31
 * @LastEditTime: 2021-01-19 10:52:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/api/order.js
 */
import request from "@/utils/request";
// 订单详情
export async function getUserOrder(params) {
  const url = `/api/front/order/order/getUserOrder`;
  return request(url, { params });
}
// 订单列表
export async function findClientRetailOrderByParam(params) {
  const url = `/api/front/retailOrder/findClientRetailOrderByParam`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 取消订单
export async function cancelOrder(params) {
  const url = `/api/front/order/order/cancelOrder`;
  return request(url, {
    method: "PUT",
    data: params
  });
}
// 申请退款退款人信息
export async function getContactor(params) {
  const url = `/api/front/order/order/getContactor`;
  return request(url, { params });
}
// 删除订单
export async function deleteOrder(params) {
  const url = `/api/front/order/order/deleteOrder/${params.orderSn}`;
  return request(url, {
    method: "DELETE",
    data: params
  });
}
// 再次购买
export async function againBuy(params) {
  const url = `/api/front/order/cart/againBuy`;
  return request(url, {
    method: "PUT",
    data: params
  });
}
// 自提未提货商品售后
export async function addUnPickedAfterSale(params) {
  const url = `/api/front/order/after/cancelSelfPickupItem`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 查询已取消的售后id
export async function getManualCanceledAfterSaleIds(params) {
  const url = `/api/front/order/after/getManualCanceledAfterSaleIds`;
  return request(url, { params });
}
// 确认收货
export async function confirmOrder(params) {
  const url = `/api/front/order/order/confirmOrder/${params.subOrderSn}`;
  return request(url, {
    method: "PUT",
    data: params
  });
}
// 查看物流
export async function getTrackingDataBySubOrderSn(params) {
  const url = `/api/front/order/subOrder/getTrackingDataBySubOrderSn`;
  return request(url, { params });
}
// 小b查看订单物流信息
export async function getTrackingDataByOrderSn(params) {
  const url = `/api/front/order/order/getTrackingDataByOrderSn`;
  return request(url, { params });
}
// 确认订单兑换鲜奶页面
export async function toExchangeCardVoucher(params) {
  const url = `/api/front/order/card/toExchangeCardVoucher/${params.id}`;
  return request(url, {
    method: "PUT",
    data: params
  });
}
// 确认兑换
export async function exchangeCardVoucher(params) {
  const url = `/api/front/order/card/exchangeCardVoucher`;
  return request(url, {
    method: "PUT",
    data: params
  });
}
// 售后列表
export async function getAfterSaleList(params) {
  const url = `/api/front/aftersale/user/getAfterSaleList`;
  return request(url, { params });
}
// 售后列表
export async function getAfterSaleInfo(params) {
  const url = `/api/front/aftersale/user/getAfterSaleInfo`;
  return request(url, { params });
}
// 删除售后
export async function deleteAfterSale(params) {
  const url = `/api/front/aftersale/user/deleteAfterSale/${params.id}`;
  return request(url, {
    method: "PUT"
  });
}
// 协商历史
export async function getNegotiationHistory(params) {
  const url = `/api/front/aftersale/log/getNegotiationHistory`;
  return request(url, { params });
}
// 填写物流信息
export async function commitLogistics(params) {
  const url = `/api/front/aftersale/user/commitLogistics`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 配送计划
export async function getDistributionPlan(params) {
  const url = `/api/front/order/period/getDistributionPlan`;
  return request(url, { params });
}
// 配送计划修改日期
export async function updateDistributionPlanPlanDeliveredAt(params) {
  const url = `/api/front/order/period/updateDistributionPlanPlanDeliveredAt`;
  return request(url, {
    method: "PUT",
    data: params
  });
}
// 配送计划修改地址
export async function updateDistributionPlanAddress(params) {
  const url = `/api/front/order/period/updateDistributionPlanAddress`;
  return request(url, {
    method: "PUT",
    data: params
  });
}
// 售后物流列表
export async function getAfterLogistics(params) {
  const url = `/api/front/aftersale/user/getAfterLogistics`;
  return request(url, { params });
}
// 撤销售后物流列表
export async function cancelAfterSale(params) {
  const url = `/api/front/aftersale/user/cancelAfterSale/${params.id}`;
  return request(url, {
    method: "PUT"
  });
}
// 获取订单可售后商品
export async function getOptionalAfterOrder(params) {
  const url = `/api/front/order/after/getOptionalAfterOrder`;
  return request(url, { params });
}
// 获取订单可售后鲜奶周期
export async function getPeriodOptionalAfterOrder(params) {
  const url = `/api/front/order/after/getPeriodOptionalAfterOrder`;
  return request(url, { params });
}
// 申请售后
export async function addAfterSale(params) {
  const url = `/api/front/aftersale/user/addAfterSale`;
  return request(url, {
    method: "POST",
    data: params
  });
}
// 微信支付
export async function paymentPage(params) {
  const url = `/api/payment/wechatpay/paymentPage`;
  return request(url, {
    method: "POST",
    data: params
  });
}
//支付成功通知
export async function paySuccessd(params) {
  const url = `/api/payment/wechatpay/paySuccessd`;
  return request(url, {
    method: "PUT",
    data: params
  });
}
//支付
export async function jsticket(params) {
  const url = `/api/payment/wechatpay/jsticket`;
  return request(url, { params });
}
//扫码领取礼品卡
export async function queryCardVoucherUserByIdNoUserId(params) {
  const url = `/api/front/product/cardVoucherUser/queryCardVoucherUserByIdNoUserId/${params.id}`;
  return request(url);
}
//立即领取礼品卡
export async function presentCardVoucherUser(params) {
  const url = `/api/front/product/cardVoucherUser/presentCardVoucherUser`;
  return request(url, {
    method: "PUT",
    data: params
  });
}
// 鲜奶配送计划查看物流
export async function getTrackingDataByTrackingNo(params) {
  const url = `/api/front/order/period/getTrackingDataByTrackingNo`;
  return request(url, { params });
}

// Stripe支付
export async function stripePay(params) {
  const url = `/api/payment/stripe/paymentPage`;
  return request(url, {
    method: "POST",
    data: params
  });
}

// 线下支付凭证上传
export async function uploadOfflineVoucher(params) {
  const url = `/api/payment/offline/uploadVoucher`;
  return request(url, {
    method: "POST",
    data: params
  });
}

// 获取线下支付开票企业信息
export async function getCorporatePaymentInformation(params) {
  const url = `/api/front/order/order/getCorporatePaymentInformation`;
  return request(url, { params });
}

// 提交线下支付凭证
export async function uploadPaymentVoucher(params) {
  const url = `/api/front/order/order/uploadPaymentVoucher`;
  return request(url, {
    method: "POST",
    data: params
  });
}

// 订单数量状态接口
export async function getClientRetailOrderState() {
  const url = `/api/front/retailOrder/getClientRetailOrderState`;
  return request(url);
}

// Stripe Elements 卡支付 - 创建 PaymentIntent
export async function createStripePayment(params) {
  const url = `/api/payment/tp/stripe/createPayment`;
  return request(url, {
    method: "POST",
    data: params
  });
}

// 获取支付结果信息
export async function getPaymentInfo(params) {
  const url = `/api/order/order/getPaymentInfo`;
  return request(url, { params, loading: false });
}

// 订单详情 (代客下单)
export async function loadFastOrderDetailDis(params) {
  const url = "/api/front/dsorder/order/getShareOrder";
  return request(url, { params });
}

// 获取支付配置参数
export async function wechatPayFastOrderDis(params) {
  const url = "/api/payment/wechatpay/fastPaymentPage";
  return request(url, {
    method: "POST",
    data: params
  });
}

// 获取支付配置参数
export async function wechatPayStoreOrder(params) {
  const url = "/api/payment/wechatpay/paymentStorePage";
  return request(url, {
    method: "POST",
    data: params
  });
}

// Jsticket
export async function loadJsticketFastOrderDis(params) {
  const url = `/api/payment/wechatpay/jsticket`;
  return request(url, { params });
}

// 更新订单实名信息
export async function updateRealName(params) {
  const url = "/api/front/dsorder/order/updateRealName";
  return request(url, {
    method: "PUT",
    data: params
  });
}

export async function paySuccessNoticeBackgroundDis(params) {
  const url = "/api/payment/wechatpay/paySuccessd";
  return request(url, {
    method: "PUT",
    data: params
  });
}

// 订单详情（全球购）
export async function loadFastOrderDetail(params) {
  const url = "/api/front/order/order/getShareOrder";
  return request(url, { params });
}

// 更新订单实名信息（全球购）
export async function updateRealNameQQG(params) {
  const url = "/api/front/order/order/updateRealName";
  return request(url, {
    method: "PUT",
    data: params
  });
}
